import { Box, Card, Checkbox, Stack, Typography } from '@mui/material';

import StatusBar from '@/designs-dev/device/StatusBar';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import Navigation from '@/karehero-app/shell/Navigation';
import Body from '@/karehero-app/shell/Body';
import { CARE_PROFILE } from '@/karehero-app/tell-us-once/intake/content';
import { ARCHITECTURE_ACTIONS } from '@/karehero-app/architecture/Architecture.content';

// PROPOSED. Actions, without the filters.
//
// A tab of its own, as in the master, but the To do / Done / All pills are
// gone. They filter a list that is rarely longer than a phone screen, which
// puts a control above the rows that has to be read before them, and the
// answer to "what is left" is the list itself.
const ArchitectureActions = ({
  onNotifications,
  onAction,
  title = CARE_PROFILE.person,
  onSwitch,
}: {
  /** Bell tap — opens the notification centre. Omitted in stories/handover. */
  onNotifications?: () => void;
  /** An action row tap. Inert until each one has somewhere to go. */
  onAction?: () => void;
  /** Who the bar names. The architecture concepts pass whoever was picked. */
  title?: string;
  /** Someone else picked in the bar's switcher. See Navigation's `onSwitch`. */
  onSwitch?: (name: string) => void;
} = {}) => (
  <ScreenRoot>
    <StatusBar />

    <Navigation
      title={title}
      onNotifications={onNotifications}
      avatarInitials='OP'
      onSwitch={onSwitch}
    />

    <Body>
      {/* No page heading. The tab is called Actions and is lit in the nav
          directly below, and the list is the whole screen, so a title over it
          would be the same label twice. */}
      <Stack spacing={1.5}>
        {ARCHITECTURE_ACTIONS.map((action) => (
          <Card
            key={action.id}
            variant='listItem'
            onClick={onAction}
            sx={{ p: 2 }}
          >
            <Stack
              sx={{ alignItems: 'flex-start' }}
              direction='row'
              spacing={1.5}
            >
              {/* Ticking is the point of a to-do, so the control is on the
                    row rather than behind opening it. */}
              <Checkbox sx={{ p: 0, mt: '2px' }} color='primary' />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant='h6'>{action.label}</Typography>
                <Typography sx={{ color: 'text.secondary' }} variant='body2'>
                  {action.note}
                </Typography>
              </Box>
            </Stack>
          </Card>
        ))}
      </Stack>
    </Body>
  </ScreenRoot>
);

export default ArchitectureActions;
